export const isPresent = (v) => v !== null && v !== undefined && v !== "";
export const hasItems = (arr) => Array.isArray(arr) && arr.length > 0;

export const getYouTubeId = (url) => {
  if (!url) return null;
  const patterns = [
    /youtube\.com\/shorts\/([^?&/]+)/,
    /youtu\.be\/([^?&/]+)/,
    /youtube\.com\/watch\?v=([^?&/]+)/,
    /youtube\.com\/embed\/([^?&/]+)/,
  ];
  for (const pattern of patterns) {
    const match = url.match(pattern);
    if (match) return match[1];
  }
  return null;
};
